import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        // Check if this is a Rainbow Wallet extension error
        const errorMessage = error?.message || '';
        const errorStack = error?.stack || '';
        const errorName = error?.name || '';
        const combinedStr = `${errorMessage} ${errorStack} ${errorName}`;
        const isRainbowError = 
            combinedStr.includes('chrome.runtime.sendMessage') ||
            combinedStr.includes('Extension ID') ||
            combinedStr.includes('Error in invocation of runtime.sendMessage') ||
            combinedStr.includes('opfgelmcmbiajamepnmloijbpoleiama') ||
            combinedStr.includes('rainbow') ||
            (errorMessage.includes('runtime.sendMessage') && errorStack.includes('chrome-extension'));

        if (isRainbowError) {
            // Suppress Rainbow Wallet errors - don't show error UI
            console.debug('Suppressed Rainbow Wallet extension error in ErrorBoundary:', errorMessage);
            return { hasError: false, error: null }; // Don't trigger error state
        }

        // For other errors, show error state
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Check if this is a Rainbow Wallet extension error
        const errorMessage = error?.message || '';
        const errorStack = error?.stack || '';
        const errorName = error?.name || '';
        const errorInfoStr = JSON.stringify(errorInfo || '');
        const combinedStr = `${errorMessage} ${errorStack} ${errorName} ${errorInfoStr}`;
        
        const isRainbowError = 
            combinedStr.includes('chrome.runtime.sendMessage') ||
            combinedStr.includes('Extension ID') ||
            combinedStr.includes('Error in invocation of runtime.sendMessage') ||
            combinedStr.includes('opfgelmcmbiajamepnmloijbpoleiama') ||
            combinedStr.includes('rainbow') ||
            (errorMessage.includes('runtime.sendMessage') && errorStack.includes('chrome-extension'));

        if (isRainbowError) {
            // Suppress Rainbow Wallet errors
            console.debug('Suppressed Rainbow Wallet extension error in componentDidCatch:', errorMessage);
            return; // Don't log or handle the error
        }

        // Log other errors normally
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }

    render() {
        // If it's a Rainbow Wallet error, we've already suppressed it in getDerivedStateFromError
        // So hasError will be false and we'll render children normally
        if (this.state.hasError) {
            // For real errors, show error UI
            return (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                    <h2>Something went wrong</h2>
                    <p>An unexpected error occurred. Please refresh the page.</p>
                    <button onClick={() => window.location.reload()}>Refresh Page</button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
